/**
 * MediaDevices.
 *
 * @copyright Realeyes OU. All rights reserved.
 */


import MediaStream from './MediaStream';
import MediaStreamError from './MediaStreamError';

export default class MediaDevices {
    /**
     * Creates a media devices controller object.
     *
     * @param {PluginRecordingApi} pluginContext Plugin recording context.
     */
    constructor(pluginContext) {
        /** @type {PluginRecordingApi} */
        this.pluginContext = pluginContext;
    }

    /**
     * Resolves with a MediaStream object.
     *
     * @param {Array.<IDevice>} devices for get stream operation
     * @return {Promise.<MediaStream, MediaStreamError>}
     */
    getStream(devices = []) {
        return this.pluginContext.mediaDevices.getStream(devices)
            .then(stream => new MediaStream(stream))
            .then(stream => stream.getTracks()
                .then((tracks) => {
                    // FIXME: we should use IDevice.getType() method to extract device types
                    // FIXME: this should be fixed in DC site, it should call getStream() with
                    // FIXME: an array of IDevice
                    const deviceTypes = devices.map(d => d.deviceType);
                    const trackTypes = tracks.map(t => t.getType());

                    for (const deviceType of deviceTypes) {
                        if (trackTypes.indexOf(deviceType) === -1) {
                            return stream.dispose().then(() => {
                                throw new MediaStreamError('Can not satisfy constraints');
                            });
                        }
                    }

                    return stream;
                }), (err) => { throw new MediaStreamError(err); });
    }

    /**
     * Resolves with an array of available media devices.
     *
     * @return {Promise.<Array.<IDevice>>}
     */
    getDevices() {
        return this.pluginContext.mediaDevices.getDevices();
    }
}
